import { c as _c } from "react/compiler-runtime";
import { Text } from "@flat-ui";
import { StorageUsage } from "@pages/settings/subscription-settings/storage-usage";
import { SubscriptionLimit } from "@pages/settings/subscription-settings/usage-metrics/subscription-limit";
import { limitTooltips } from "@pages/settings/subscription-settings/usage-metrics/limit-tooltips";
import { selectQuotasSelector, selectStorageUsedSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
/** The title of the section of each limit */
const LIMIT_SECTION_TITLE = {
  ["project_area"]: "Area",
  ["project_count"]: "Active projects",
  ["storage"]: "Storage"
};
/** Checks if a certain quota was exceeded */
export function hasExceededQuota(quota) {
  return (quota?.current ?? 0) > (quota?.limit ?? 0);
}

/**
 * Custom hook to return a section per limit of the plan for the subscription page, explained in
 * its subtitle.
 *
 * The active members limit is left out, as the Sphere XG seats section shows it.
 */
export function useUsageMetrics() {
  const $ = _c(6);
  const selectStorageUsed = useAppSelector(selectStorageUsedSelector);
  const selectQuotas = useAppSelector(selectQuotasSelector);
  let usageSectionProps;
  if ($[0] !== selectQuotas || $[1] !== selectStorageUsed) {
    usageSectionProps = selectQuotas.filter(_temp).map(_temp2);
    if (selectStorageUsed) {
      let t0;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = <StorageUsage />;
        $[3] = t0;
      } else {
        t0 = $[3];
      }
      usageSectionProps.push(createLimitSection("storage", t0));
    }
    $[0] = selectQuotas;
    $[1] = selectStorageUsed;
    $[2] = usageSectionProps;
  } else {
    usageSectionProps = $[2];
  }
  let t0;
  if ($[4] !== usageSectionProps) {
    t0 = {
      usageSectionProps
    };
    $[4] = usageSectionProps;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
}

/** Returns the section of a limit, showing how much of it is used */
function _temp2(limit) {
  return createLimitSection(limit.identifier, <SubscriptionLimit limit={limit} />);
}
function _temp(t0) {
  const {
    identifier
  } = t0;
  return identifier !== "storage" && identifier !== "user_role";
}
function createLimitSection(identifier, usage) {
  return {
    title: LIMIT_SECTION_TITLE[identifier] ?? identifier,
    subtitle: limitTooltips[identifier],
    items: [{
      label: <Text variant="bodyM">In use</Text>,
      content: usage,
      shouldHideTopBorder: true
    }]
  };
}